import message from '@web-common/components/UI/Message/SiriusMessage';
import copy from 'copy-to-clipboard';
export const selectElement = (textElement, win = window, doc = document) => {
    const selection = win.getSelection();
    const range = doc.createRange();
    range.selectNodeContents(textElement);
    selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
    selection === null || selection === void 0 ? void 0 : selection.addRange(range);
};
export const copyText = (str = '', options = {}) => {
    copy(str, Object.assign({ format: 'text/plain' }, options));
};
export const paste = async (needToast = true, msg = '因为您的浏览器版本过低，请使用键盘快捷键（Ctrl+V）。') => {
    try {
        if (await isSupportPaste()) {
            const clipboardData = await navigator.clipboard.readText();
            return clipboardData;
        }
        else {
            needToast && message.error(msg);
        }
    }
    catch (e) {
        console.error('patse error', e);
        message.error(msg);
    }
    return '';
};
export const isSupportPaste = async () => {
    if (window.navigator && window.navigator.clipboard && typeof window.navigator.clipboard.readText === 'function') {
        try {
            await navigator.clipboard.readText();
            return true;
        }
        catch (e) {
            return false;
        }
    }
    return false;
};
